module.exports = __webpack_public_path__ + "static/img/code.28a77fc6.png";